import type { FrontendWidget } from '../types';
import { BookAppointmentModalWidget } from './BookAppointmentModalWidget';
import { BookAppointmentModalWidgetC } from './BookAppointmentModalWidgetC';
import type {
  BookAppointmentModalConfig,
  BookAppointmentModalResolved,
} from './types';

// resolveNestedZones wraps component fields in an array even when
// repeatable=false; unwrap to the single object the frontend types expect.
const first = <T>(value: T | T[]): T =>
  Array.isArray(value) ? value[0] : value;

export const bookAppointmentModalWidget: FrontendWidget<
  BookAppointmentModalConfig,
  BookAppointmentModalResolved
> = {
  componentType: 'widgets.book-appointment-modal',
  displayName: 'Book Appointment Modal',
  ComponentA: BookAppointmentModalWidget,
  ComponentC: BookAppointmentModalWidgetC,
  resolveSync: (config) => ({
    ...config,
    pickerTexts: config.pickerTexts ? first(config.pickerTexts) : undefined,
  }),
};
